<template>
    <div class="nav_top">
        <div class="hamburger">
            <img :src="logo_small" alt="南软科技">
        </div>
        <el-menu class = "nav_top_bar" :default-active="$route.path" mode="horizontal" background-color="#1F7CFF" text-color="#ffffff" active-text-color="#ffffff" router @select="handleSelect">
            <el-menu-item :index="'/homepage'" >首页</el-menu-item>
            <el-menu-item @click.native="go(1)">数字物流生态</el-menu-item>
            <el-menu-item @click.native="go(2)">货物跟踪</el-menu-item>
            <el-menu-item :index="'/aboutUsUs'" >关于我们</el-menu-item>
        </el-menu>
        <div class="button_login">
          <span class="iconfont icon-dianhua"></span>4008-539-529
        </div>
        <!-- <div class="nav_top_operating">
            <el-dropdown style="float:right;" trigger="click" @command="roleHandle">
                <span class="el-dropdown-link">
                    {{userName}}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="Center">个人中心</el-dropdown-item>
                    <el-dropdown-item command="Login">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div> -->
    </div>
</template>

<script>
export default {
  // inject:['reload'],
  name: "nav-top-bar",
  data() {
    return {
      logo_small: require("./../../static/home/logo.png"),
      userName: sessionStorage.userName
    };
  },
  created(){
    console.log(this.$route.path)
  },
  methods: {
    roleHandle(val) {
      this.$router.push({ name: val });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    go (type) {
      let url
      if (type == 1) {
        url = 'https://www.wlyuan.com.cn'
      } else if (type == 2) {
        url = 'https://www.wlyuan.com.cn/#/Visual'
      }
      window.open(url, '_blank');
    }
  },
  components:{
  }
};
</script>



// WEBPACK FOOTER //
// src/components/NavTopBar.vue